"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObject = function (value) {
    return Object.prototype.toString.call(value) === '[object Object]';
};
//# sourceMappingURL=object.js.map